import script from "./MySuggestions.vue?vue&type=script&setup=true&lang=js"
export * from "./MySuggestions.vue?vue&type=script&setup=true&lang=js"

import "./MySuggestions.vue?vue&type=style&index=0&id=074462ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-074462ba"]])

export default __exports__